module.exports = __webpack_public_path__ + "media/images/cvv-f83f381c77095f3c9ae7c4d7d9cfcfca.jpg";